import { ErrorMessage, Field, Form, Formik } from 'formik'
import moment from 'moment'
import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter'
import {
  getStockBarCode,
  updateStockProduct
} from 'src/services/stock/stockService'
import { validUserByBarcode } from 'src/services/user/userApi'
import * as Yup from 'yup'
import Button from 'src/components/Button'
import FlexLayout from 'src/components/FlexLayout'
import Loading from 'src/components/Loading'
import TagPrinterManager from 'src/components/TagPrinterManager'
import WithdrawTag from 'src/components/Tags/WithdrawTag'
import Text from 'src/components/Text'
import Helper from 'src/services/Helper'
import './../../App.css'
import ModalWithdrawSuccess from './components/ModalWithdrawSuccess'
import WithdrawAddressComponent from './components/WithdrawAddressComponent'
import { X } from 'react-feather'

const styleField = {
  background: 'rgba(246, 246, 246, 0.6)',
  border: 0,
  borderBottom: `3px solid #002d62`,
  width: '250px'
}

function Withdraw() {
  const [loading, setLoading] = useState(false)
  const [withdraw, setWithdraw] = useState({
    barcodeUser: undefined,
    productQty: undefined,
    addressId: undefined
  })
  const [barcodeError, setBarcodeError] = useState('')
  const [finishFormError, setFinishFormError] = useState('')
  const [finishFormSuccess, setFinishFormSuccess] = useState('')
  const [show, setShow] = useState(false)
  const [showTagManager, setShowTagManager] = useState(false)
  const [etiquetas, setEtiquetas] = useState([])
  const [produto, setProduto] = useState(undefined)
  const [dataTable, setDataTable] = useState(undefined)
  const [productSelected, setProductSelected] = useState(undefined)
  const [addressSelected, setAddressSelected] = useState(undefined)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const [listAddressesGondola, setListAddressesGondola] = useState([])
  const [addresses, setAddresses] = useState(undefined)
  const [disableButtons, setDisableButtons] = useState(false)  
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { fc } = useFulfillmentCenter()

  const handleAtClose = () => {
    setWithdraw({
      barcodeUser: undefined,
      productQty: undefined,
      addressId: undefined
    })
    setFinishFormError('')
    setFinishFormSuccess('')
    setDataTable(undefined)
    setProduto(undefined)
    setProductSelected(undefined)
    setAddressSelected(undefined)
    setListAddressesGondola([])
  }

  const handleCloseModal = () => {
    setShow(false)
    handleAtClose()
  }

  const handleCloseLabel = () => {
    setShowTagManager(false)
    setShowSuccessAlert(true)
    handleAtClose()
  }

  const handleSubmit = async (values, resetForm) => {
    setIsSubmitting(true)
    setLoading(true)
    const response = await getStockBarCode(values.codeBar, fc.id)

    if (!response.isOk) {
      setLoading(false)
      setBarcodeError('Barcode Inválido')
      setIsSubmitting(false)
      return
    }

    setLoading(false)
    setIsSubmitting(false)
    setBarcodeError('')

    const stockData = response.data.estoques.map((estoque) => {
      return {
        ...estoque,
        endereco: `${estoque.galpao}-${estoque.rua}-${estoque.posicao_pallete}-${estoque.escaninho_nivel}`,
        resetForm: resetForm,
        barcode: values.codeBar
      }
    })
    setDataTable(stockData)
    setProduto(response.data.produto)
    setAddresses(response.data.enderecos)
    setListAddressesGondola([])
    setProductSelected(undefined)
  }

  const handleShow = (id_localizacao, id_modelo, id_lote, resetForm) => {
    setShow(true)
    setWithdraw((prev) => {
      return {
        ...prev,
        localizacao: id_localizacao,
        idModelo: id_modelo,
        id_lote: id_lote,
        resetForm: resetForm
      }
    })
  }

  const handleChangeBarcode = (el, setFieldValue) => {
    let value = el.target.value.trimStart()
    if (Helper.ValidateBarcodeProduct(value) || value === '') {
      setFieldValue('codeBar', value)
    }
  }

  const onRowDoubleClick = (state, rowInfo, instance) => {
    return {
      onClick: (e) => {
        let rowSelected = rowInfo.original
        let allRow = addresses.filter(
          (address) =>
            address.id_localizacao != rowSelected.id_localização &&
            address.id_localizacao != ''
        )
        setProductSelected(rowSelected)
        setListAddressesGondola((prevState) =>
          Helper.getUniqueListBy(allRow, 'id_localizacao')
        )
      },
      style: {
        backgroundColor:
          rowInfo &&
          rowInfo.original &&
          productSelected &&
          rowInfo.original.id_estoque_lote === productSelected.id_estoque_lote
            ? '#808080'
            : 'initial'
      }
    }
  }

  const handleWithdrawProductToStockOrGondola = async () => {
    setShow(false)
    setDisableButtons(true)
    setLoading(true)
    
    const response = await updateStockProduct(
      addressSelected.addressId,
      parseInt(withdraw.productQty),
      productSelected.id_estoque_lote,
      withdraw.barcodeUser
    )

    if (!response.isOk) {
      setLoading(false)
      setDisableButtons(false)
      setFinishFormSuccess(
        response.data.message || 'Ocorreu um problema ao dar saída no produto !'
      )
      return
    }
    let data = response.data.new_location
    let itemToPrint = {
      warehouse: addressSelected.warehouse.toUpperCase(),
      street: addressSelected.street.toUpperCase(),
      shelf: addressSelected.shelf.toUpperCase(),
      bin: addressSelected.bin.toUpperCase(),
      withdrawDate: moment(data.data_movimentacao).format('DD/MM/YYYY HH:mm'),
      description: data.desc_produto,
      addressBarcode:
        addressSelected.warehouse +
        addressSelected.street +
        addressSelected.shelf +
        addressSelected.bin,
      barcodeSku: productSelected.barcode,
      codModelo: data.cod_produto,
      printed: false,
      fc: data.fc?.name
    }

    itemToPrint = Helper.WhiteSpaceTreatement(itemToPrint)

    setFinishFormSuccess(response.data.status)
    setFinishFormError('')

    var etiquetas = [
      <WithdrawTag key={itemToPrint} obj={{ ...itemToPrint, printed: false }} />
    ]
    
    setEtiquetas(etiquetas)
    setShowTagManager(true)
    setLoading(false)
  }

  const closeShowSuccess = () => {
    setShowSuccessAlert(false)
    setDisableButtons(false)
  }

  return (
    <>
      <div>
        <Text textType="header" text="withdraw" />
        <Formik
          initialValues={{
            codeBar: '',
            desc: ''
          }}
          onSubmit={async (values, { resetForm }) =>
            handleSubmit(values, resetForm)
          }
        >
          {({ setFieldValue }) => (
            <Form style={{ marginTop: '40px' }}>
              <div style={{ display: 'inline-flex', width: '100%' }}>
                <div
                  style={{
                    display: 'inline-flex',
                    width: '70%',
                    maxWidth: '700px'
                  }}
                >
                  <div className="form-group mr-5">
                    <label htmlFor="codeBar">Código de Barras:</label>
                    <br />
                    <Field
                      required
                      style={styleField}
                      id="codeBar"
                      name="codeBar"
                      onChange={(el) => {
                        handleChangeBarcode(el, setFieldValue)
                      }}
                      disabled={isSubmitting}
                    />
                    {barcodeError && (
                      <p style={{ color: 'red', marginTop: '10px' }}>
                        {' '}
                        {barcodeError}{' '}
                      </p>
                    )}
                  </div>
                  <Button
                    text="withdraw.form.search"
                    type="submit"
                    style={{ height: '40px', marginTop: '20px' }}
                  />
                </div>
                {produto && (
                  <div
                    style={{
                      margin: '0 15px',
                      background: 'white',
                      borderRadius: '5px',
                      boxShadow: '0px 0px 10px 1px rgba(0,0,0,0.44)',
                      padding: '10px',
                      width: '50%'
                    }}
                  >
                    <p style={{ fontSize: '16px', margin: '0' }}>
                      {produto.modelo_shopper} - {produto.descricao}
                    </p>
                  </div>
                )}
              </div>
            </Form>
          )}
        </Formik>
        <Text
          textType="header"
          text="withdraw.table.title"
          style={{ marginTop: '20px' }}
        />
        <FlexLayout style={{ height: '64vh', width: '100%' }}>
          <ReactTable
            style={{
              fontSize: '0.7em',
              maxWidth: '700px',
              width: '70%',
              height: '100%',
              overflowX: 'scroll'
            }}
            data={dataTable}
            pageSizeOptions={[20, 30, 50, 100, 200, 500]}
            columns={[
              {
                Header: 'Id Lote',
                id: 'id_lote',
                accessor: 'id_lote',
                width: 60
              },
              {
                Header: 'Endereço',
                id: 'endereco',
                accessor: 'endereco',
                width: 250
              },
              {
                Header: 'Quantidade',
                id: 'quantidade',
                accessor: 'quantidade',
                width: 100
              },
              {
                Header: 'Data de Validade',
                id: 'data_validade',
                accessor: 'data_validade',
                width: 120,
                sortMethod: (a, b) => {
                  a = new Date(a).getTime()
                  b = new Date(b).getTime()
                  return b > a ? 1 : -1
                }
              }
            ]}
            defaultPageSize={20}
            className="-striped -highlight"
            getTrProps={onRowDoubleClick}
            previousText={'Anterior'}
            nextText={'Próxima'}
            loadingText={'Carregando...'}
            noDataText={'Sem registros'}
            pageText={'Página'}
            ofText={'de'}
            rowsText={'Registros'}
          />
          {productSelected && (
            <WithdrawAddressComponent
              productSelected={productSelected}
              listAddressesGondola={listAddressesGondola}
              setAddressSelected={setAddressSelected}
              handleShow={handleShow}
              fcSelected={fc}
              disableButtons={disableButtons}
            />
          )}
        </FlexLayout>
        <Modal show={show} onHide={handleCloseModal} backdrop="static">
          <Modal.Header>
            <Modal.Title>Impressão e Finalização de Saída</Modal.Title>
            <X cursor="pointer" onClick={handleCloseModal} />
          </Modal.Header>
          <Modal.Body>
            <Formik
              initialValues={{
                quantidadeProdutos: '',
                cracha: '',
                localizacao: ''
              }}
              validationSchema={Yup.object().shape({
                cracha: Yup.string().test(
                  'cracha',
                  'receivement.form.error.barcodeUser',
                  () => validUserByBarcode(withdraw?.barcodeUser)
                )
              })}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={async () => handleWithdrawProductToStockOrGondola()}
            >
              {({ values, validateField, setTouched, isSubmitting }) => (
                <Form>
                  <div>
                    <div className="form-group ml-5">
                      <label htmlFor="cracha">Cracha:</label>
                      <br />
                      <Field
                        style={styleField}
                        required
                        value={withdraw?.barcodeUser}
                        onChange={(e) =>
                          setWithdraw((prevState) => ({
                            ...prevState,
                            barcodeUser: e.target.value
                          }))
                        }
                        onBlur={() => {
                          validateField('cracha')
                          setTouched(values)
                        }}
                        type="password"
                        id="cracha"
                        name="cracha"
                      />
                      <ErrorMessage
                        component={Text}
                        name="cracha"
                        style={{ color: 'red', margin: '5px 0 0 0' }}
                      />
                    </div>
                    <div className="form-group ml-5">
                      <label htmlFor="quantidadeProdutos">
                        Quantos produtos deseja retirar?
                      </label>
                      <br />
                      <Field
                        style={styleField}
                        required
                        value={withdraw?.productQty}
                        onChange={(e) =>
                          setWithdraw((prevState) => ({
                            ...prevState,
                            productQty: e.target.value
                          }))
                        }
                        min="1"
                        type="number"
                        id="quantidadeProdutos"
                        name="quantidadeProdutos"
                      />
                    </div>

                    <div hidden className="form-group">
                      <Field
                        style={styleField}
                        value={withdraw?.addressId}
                        id="localizacao"
                        name="localizacao"
                      />
                    </div>
                    <div className="form-group">
                      {finishFormError && (
                        <p
                          style={{
                            color: 'red',
                            marginTop: '10px',
                            marginLeft: '50px',
                            fontWeight: 'bold'
                          }}
                        >
                          {' '}
                          {finishFormError}{' '}
                        </p>
                      )}
                      {finishFormSuccess && (
                        <p
                          style={{
                            color: 'green',
                            marginTop: '10px',
                            marginLeft: '50px'
                          }}
                        >
                          {' '}
                          {finishFormSuccess}{' '}
                        </p>
                      )}
                    </div>
                    <div className="row mt-5">
                      <div className="col d-flex justify-content-center">
                        <Button
                          text="receivement.form.finish"
                          type="submit"
                          isDisabled={isSubmitting}
                        />
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </Modal.Body>
        </Modal>
        {etiquetas.length > 0 && showTagManager && (
          <TagPrinterManager
            setShowTagModal={setShowTagManager}
            showTagModal={showTagManager}
            labelsToPrint={etiquetas}
            setLabelsToPrint={setEtiquetas}
            donePrint={handleCloseLabel}
          />
        )}
      </div>
      <ModalWithdrawSuccess show={showSuccessAlert} action={closeShowSuccess}/>

      <Loading
        loading={loading}
        style={{ opacity: '0.6', zIndex: 9999 }}
      ></Loading>
    </>
  )
}

export default Withdraw
